// src/pages/services/DetoxRejuvenation.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import leaf from '../../assets/leaf1.png';
import heroImg from '../../assets/Detox & Rejuvenation.png';
import doctorImg from '../../assets/doctors4.png';
import Navbar from '../../common/Navbar';
import Footer from '../../common/Footer';

const DetoxRejuvenation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const benefits = [
    { icon: "", title: "Total Cleansing", desc: "Eliminates deep-seated toxins from tissues" },
    { icon: "", title: "Boosted Energy", desc: "Restores natural vitality and stamina" },
    { icon: "", title: "Improved Digestion", desc: "Reignites Agni (digestive fire)" },
    { icon: "", title: "Stronger Immunity", desc: "Builds Ojas — the essence of immunity" },
    { icon: "", title: "Better Sleep", desc: "Promotes deep, restorative rest" },
    { icon: "", title: "Radiant Skin & Hair", desc: "Natural glow from within" }
  ];

  const steps = [
    { step: "Consultation & Planning", desc: "Personalized detox program based on your constitution" },
    { step: "Pre-Cleansing (Purvakarma)", desc: "Internal & external oleation to loosen toxins" },
    { step: "Main Detox Procedures", desc: "Gentle elimination therapies tailored to your needs" },
    { step: "Rasayana (Rejuvenation)", desc: "Nourishing herbs & therapies to rebuild strength" },
    { step: "Lifestyle Guidance", desc: "Diet & routine to maintain your renewed health" }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#E8E0D5] to-[#F8F3EA]">
        <div className="absolute inset-0 bg-black/45 z-10"></div>
        <img 
          src={heroImg} 
          alt="Detox & Rejuvenation" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        <div className="relative z-20 text-center px-4 sm:px-6 max-w-5xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-playfair font-bold text-white mb-4 sm:mb-6 drop-shadow-2xl leading-tight">
            Detox & Rejuvenation
          </h1>
          <p className="text-lg sm:text-xl md:text-3xl text-white/95 font-light leading-relaxed max-w-3xl sm:max-w-4xl mx-auto drop-shadow-lg">
            Purify your body, recharge your energy, and awaken your natural vitality through authentic Ayurvedic cleansing.
          </p>
        </div>

        {/* Floating Leaves */}
        <img src={leaf} className="absolute top-20 left-10 w-24 sm:w-32 opacity-30 animate-float" />
        <img src={leaf} className="absolute bottom-32 right-16 w-32 sm:w-40 opacity-25 animate-float" style={{ animationDelay: '2s' }} />
        <img src={leaf} className="absolute top-1/3 -right-20 w-40 sm:w-48 opacity-20 animate-float" style={{ animationDelay: '4s' }} />
      </section>

      {/* Benefits Section */}
      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-[#F8F3EA]">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl text-center sm:text-4xl md:text-5xl font-playfair text-[#0B2A2C] mb-10 sm:mb-16">
            Renew Body, Mind & Spirit
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10">
            {benefits.map((b, i) => (
              <div 
                key={i} 
                className="bg-white rounded-3xl p-6 sm:p-8 md:p-10 shadow-md sm:shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 md:hover:-translate-y-4 border border-[#E4D7C2]/50 flex flex-col items-center text-center"
              >
                <div className="text-5xl sm:text-6xl md:text-7xl mb-4 sm:mb-6">{b.icon}</div>
                <h3 className="text-xl sm:text-2xl md:text-2xl font-bold text-[#0B2A2C] mb-2 sm:mb-4">{b.title}</h3>
                <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Timeline */}
      <section className="py-24 px-4 sm:px-6 bg-[#E4D7C2]">
        <div className="max-w-5xl mx-auto flex flex-col gap-12">
          <h2 className="text-3xl text-center sm:text-4xl md:text-5xl font-playfair text-[#0B2A2C] mb-10 sm:mb-16">
            Your Rejuvenation Journey
          </h2>
          <div className="space-y-12 sm:space-y-16">
            {steps.map((item, i) => (
              <div key={i} className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-10">
                {/* Step Number */}
                <div className="w-16 h-16 sm:w-24 sm:h-24 bg-[#0B2A2C] text-white rounded-full flex items-center justify-center text-xl sm:text-3xl font-bold shadow-md sm:shadow-2xl flex-shrink-0">
                  {i + 1}
                </div>
                {/* Step Content */}
                <div className="flex-col text-center mx-auto flex-1 bg-white items-center rounded-3xl p-8 sm:p-10 shadow-xl border border-[#E4D7C2] text-center sm:text-left">
                  <h4 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#0B2A2C] mb-3">{item.step}</h4>
                  <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Doctor Quote */}
      <section className="py-16 sm:py-24 bg-gradient-to-r from-[#0B2A2C] to-[#1A4D4F] text-white text-center px-4 sm:px-6">
        <img 
          src={doctorImg} 
          alt="Dr. V. K. Subrahmanyeswara Rao" 
          className="w-36 h-36 sm:w-40 sm:h-40 rounded-full mx-auto mb-6 sm:mb-10 border-4 sm:border-8 border-amber-300/30 shadow-xl sm:shadow-2xl"
        />
        <blockquote className="text-xl sm:text-3xl md:text-4xl font-joan italic max-w-3xl sm:max-w-5xl mx-auto leading-relaxed">
          “True healing begins when we remove what no longer serves us — body, mind, and soul.”
        </blockquote>
        <p className="mt-6 sm:mt-10 text-base sm:text-xl opacity-90">— Dr. V. K. Subrahmanyeswara Rao</p>
      </section>

      {/* Final CTA */}
      <section className="py-16 sm:py-28 text-center bg-[#F8F3EA] px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-6xl font-playfair text-[#0B2A2C] mb-6 sm:mb-10">
          Feel Lighter, Brighter, Reborn
        </h2>
        <p className="text-base sm:text-xl text-gray-700 max-w-xl sm:max-w-2xl mx-auto mb-6 sm:mb-12">
          Start your personalized Detox & Rejuvenation program today
        </p>
        <button 
          onClick={() => navigate("/BookNow")}
          className="bg-[#0B2A2C] text-white px-12 sm:px-16 py-4 sm:py-7 rounded-full text-lg sm:text-2xl font-medium hover:bg-[#1A4D4F] transition-all hover:shadow-xl sm:hover:shadow-2xl hover:scale-105 transform"
        >
          Begin Your Detox Journey
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default DetoxRejuvenation;
